import { Track } from '../../../classes/track'
import { TrackFields } from '../../../constants'

export function findExtractableTracksWithoutArtist(tracks: Track[], separator: string): Track[] {
  return tracks
    .filter(t => !t.artist)
    .filter(t => t.title && t.title.includes(separator))
}

export function extractArtist(track: any, values: any[]): string | null {
  const field: TrackFields = values[1]
  const resultNumber: number = values[2]
  const separator: string = values[3]

  if (track[field]) {
    const split = track[field].split(separator)

    if (split.length >= resultNumber) {
      const result: string = track[field].split(separator)[resultNumber - 1]

      if (result) return result.trim()
      else return null
    } else {
      return null
    }
  }

  return null
}

export function generateNewTitle(track: any, values: any[]): string | null {
  const field: TrackFields = values[0]
  const resultNumber: number = values[1]
  const separator: string = values[2]

  if (track[field]) {
    const split = track[field].split(separator)

    if (split.length > resultNumber) {
      const title = split.slice(resultNumber).join(separator).trim()

      return title
    } else if (split.length === resultNumber) {
      const title = split.slice(0, resultNumber - 1).join(separator).trim()

      return title
    } else {
      return track[field]
    }
  } else {
    return null
  }
}
